import '../../modules/mode-components';

import * as angular from 'angular';

import { AnalyticsEvent, AnalyticsService, RunMethodType } from '@mode/shared/util-segment';

const connectDbInstrumentation = function (as: AnalyticsService) {
  return {
    scope: false,
    link: function ($scope: angular.IScope, element: JQuery, attr) {
      element.on('click.connectDbLink', () => {
        as.run(RunMethodType.Track, AnalyticsEvent.Name.ConnectDbIntentSignaled, {
          interaction_type: 'click',
          element_id: attr.connectDbInstrumentationElementId,
          account_id: attr.connectDbInstrumentationOrgId,
        });
      });

      // cleanup handlers
      $scope.$on('$destroy', () => element.off('click.connectDbLink'));
    },
  };
};

connectDbInstrumentation.$inject = ['AnalyticsService'];

angular.module('mode.components').directive('connectDbInstrumentation', connectDbInstrumentation);
